const AJS_USER_ID_KEY = 'ajs_user_id';

export const getAjsUserId = (): string => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem(AJS_USER_ID_KEY) || '';
  }

  return '';
};
